<template>
  <div class="appsFrom">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="customTabs" type="border-card" v-permit="'User.EntOrder.List'">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <div>
          <public-table
            :loading="Loading"
            :column="column"
            :tableData="orderList"
            :enableSearch="true"
            :searchItems="searchItems"
            :PageInfo="listQuery"
            @handlePaginationChange="handleSearchList"
          >
            <template v-slot:orderType="{ row }">{{
              orderTypeName(row.orderType)
            }}</template>
            <template v-slot:appName="{ row }">
              <div v-for="item in row.orderApps" :key="item.appID">
                <div>{{ item.appName }}</div>
              </div>
            </template>
            <template v-slot:appVersion="{ row }">
              <div v-for="item in row.orderApps" :key="item.appID">
                <div>{{ item.appVersion }}</div>
              </div>
            </template>
            <template v-slot:createTime="{ row }">{{
              row.createTime ? timetrans(row.createTime) : '-'
            }}</template>
            <template v-slot:payTime="{ row }">{{
              row.payTime ? timetrans(row.payTime) : '-'
            }}</template>
            <template v-slot:comboPrice="{ row }">
              <div v-for="item in row.orderApps" :key="item.appID">
                <div>{{ item.comboName }}</div>
              </div>
            </template>
            <template v-slot:serveriCycle="{ row }">
              <div v-for="item in row.orderApps" :key="item.appID">
                <div>
                  {{ item.comboQuantity }}个{{ handleCycle(item.billCycle) }}
                </div>
              </div>
            </template>

            <template v-slot:totalPrice="{ row }">
              <div>&nbsp;{{ row.totalPrice }} 元</div>
            </template>

            <template v-slot:finalPrice="{ row }">
              <div>&nbsp;{{ row.finalPrice }} 元</div>
            </template>

            <template v-slot:state="{ row }">
              <span
                :style="{
                  color: handleOrderState(row.state, 'order')
                }"
                >{{ handleOrderState(row.state) }}</span
              >
            </template>

            <template v-slot:operation="{ row }">
              <el-button size="mini" type="text" @click="handleEditSort(row)">
                详情
              </el-button>
              <span v-show="row.state === 'unpaid'">
                <el-divider direction="vertical" />
              </span>
              <el-button
                size="mini"
                type="text"
                v-show="row.state == 'unpaid'"
                @click="handlePay(row)"
              >
                支付
              </el-button>
              <span v-show="row.state != 'closed' && row.state == 'unpaid'">
                <el-divider direction="vertical" />
              </span>
              <el-button
                size="mini"
                type="text"
                v-show="row.state != 'closed' && row.state == 'unpaid'"
                @click="handleCloseOrder(row)"
              >
                关闭
              </el-button>
            </template>
          </public-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
const defaultListQuery = {
  page: 1,
  pageSize: 10,
  total: 1
};
import { handleOrderState, handleCycle } from '@/utils/dictionary';
import { timetrans } from '@/utils/validate';
import { errorHandle } from '@/utils/error';

export default {
  name: 'Appinfo',
  components: {
  },
  data() {
    const orderTypeOptions = [
      {
        label: '新购',
        value: 'new'
      },
      {
        label: '续费',
        value: 'renew'
      },
      {
        label: '试用',
        value: 'trail'
      },
      {
        label: '升级',
        value: 'upgrade'
      }
    ];
    return {
      timetrans,
      activeName:
        this.$route.params.orderState &&
        this.$route.params.orderState !== ':orderState'
          ? this.$route.params.orderState
          : 'all',
      handleOrderState,
      handleCycle,
      listQuery: defaultListQuery,
      Loading: false,
      orderList: [],
      orderTypeOptions: orderTypeOptions,
      tabList: [
        {
          label: '全部',
          name: 'all'
        },
        {
          label: '待付款',
          name: 'unpaid'
        },
        {
          label: '待审核',
          name: 'paid'
        },
        {
          label: '待交付',
          name: 'reviewed'
        },
        {
          label: '已完成',
          name: 'fulfill'
        },
        {
          label: '已关闭',
          name: 'closed'
        }
      ],
      column: [
        {
          prop: 'orderID',
          label: '订单号',
          width: '184px',
          fixed: 'left'
        },
        {
          label: '订单类型',
          prop: 'orderType',
          scopeStatus: true,
          width: '80px'
        },
        {
          prop: 'appName',
          label: '应用',
          scopeStatus: true,
          width: '150px'
        },
        {
          prop: 'appVersion',
          label: '版本',
          width: '80px',
          scopeStatus: true
        },
        {
          prop: 'comboPrice',
          label: '套餐',
          scopeStatus: true
        },
        {
          prop: 'serveriCycle',
          label: '服务周期',
          scopeStatus: true
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '180px',
          scopeStatus: true
        },
        {
          prop: 'payTime',
          label: '支付时间',
          width: '180px',
          scopeStatus: true
        },
        {
          prop: 'totalPrice',
          scopeStatus: true,
          label: '原价'
        },
        {
          prop: 'finalPrice',
          scopeStatus: true,
          label: '应付'
        },
        {
          prop: 'state',
          label: '交易状态',
          width: '78px',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          width: '150px',
          align: 'left',
          scopeStatus: true
        }
      ],
      searchItems: [
        {
          label: '订单号',
          value: '',
          name: 'orderID',
          type: 'input'
        },
        {
          label: '应用名称',
          value: '',
          name: 'appName',
          type: 'input'
        },
        {
          label: '订单类型',
          value: '',
          name: 'orderType',
          type: 'select',
          options: orderTypeOptions
        },
        {
          label: '起止时间',
          value: '',
          name: ['startTime', 'endTime'],
          type: 'timerange'
        }
      ],
      // 微信支付相关
      wechatPayVisible: false,
      wechatPayCodeUrl: '',
      wechatPayAmount: 0,
      wechatPayExpireTime: null,
      currentOrderID: '',
      payLoading: false
    };
  },
  created() {
    this.getMyOrderList();
  },
  filters: {
    filterDeliverableType(type) {
      return type && type === 'saas' ? 'SaaS' : type === 'paas' ? 'PaaS' : '';
    }
  },

  computed: {
    open_market() {
      return this.$store.state.enterprise.current.open_market;
    }
  },
  methods: {
    orderTypeName(t) {
      let typeName = t;
      this.orderTypeOptions.map((item) => {
        if (t == item.value) {
          typeName = item.label;
        }
      });
      return typeName;
    },
    handleEditSort(row) {
      this.$router.push({
        name: 'myorderDetails',
        params: { orderId: row.orderID }
      });
    },
    handlePay(row) {
      this.currentOrderID = row.orderID;
      this.payLoading = true;
      this.$store
        .dispatch('CreateWechatPay', row.orderID)
        .then((res) => {
          this.payLoading = false;
          if (res && res.data) {
            const { codeUrl, amount, expireTime } = res.data;
            this.wechatPayCodeUrl = codeUrl;
            this.wechatPayAmount = amount;
            this.wechatPayExpireTime = expireTime;
            this.wechatPayVisible = true;
          }
        })
        .catch((err) => {
          this.payLoading = false;
          errorHandle(err);
        });
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      this.listQuery.page = 1;
      this.getMyOrderList();
    },
    handleSearchList(parameter) {
      if (parameter) {
        this.listQuery = Object.assign({}, this.listQuery, parameter);
      }
      this.getMyOrderList();
    },
    getMyOrderList() {
      this.Loading = true;
      this.listQuery.state = this.activeName;
      if (this.listQuery.state == 'all') {
        this.listQuery.state = '';
      }
      this.$store
        .dispatch('GetMyOrderList', this.listQuery)
        .then((res) => {
          if (res) {
            this.orderList = res.orders;
            this.listQuery.total = res.total;
          }
          this.Loading = false;
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    handleCloseOrder(data) {
      this.Loading = true;
      this.$confirm('确定关闭订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store
            .dispatch('CloseMyOrder', data)
            .then(() => {
              this.getMyOrderList();
              this.$message({
                type: 'success',
                message: '成功'
              });
            })
            .catch(() => {
              this.Loading = false;
            });
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    // 支付成功处理
    handlePaySuccess() {
      this.wechatPayVisible = false;
      this.$message.success('支付成功');
      // 刷新订单列表
      this.getMyOrderList();
    },
    // 取消支付处理
    handlePayCancel() {
      this.wechatPayVisible = false;
      this.$message.info('已取消支付');
    },
    // 刷新二维码
    handlePayRefresh() {
      this.payLoading = true;
      this.$store
        .dispatch('CreateWechatPay', this.currentOrderID)
        .then((res) => {
          this.payLoading = false;
          if (res && res.data) {
            const { codeUrl, amount, expireTime } = res.data;
            this.wechatPayCodeUrl = codeUrl;
            this.wechatPayAmount = amount;
            this.wechatPayExpireTime = expireTime;
          }
        })
        .catch((err) => {
          this.payLoading = false;
          errorHandle(err);
        });
    },
    // 二维码过期处理
    handlePayExpired() {
      this.$message.warning('支付二维码已过期，请刷新重试');
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.cens {
  text-align: center;
  padding: 30px;
  h6 {
    font-weight: 300;
    font-size: 20px;
    text-align: center;
  }
}

.titles {
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/views/myorder/index.vue